import { createFileRoute } from '@tanstack/react-router';
import OutrasSolicitacoes from '../../-components/opcoes/outras-solicitacoes';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/hibridos/$id/outras-solicitacoes',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { cliente } = Route.useRouteContext();

  return <OutrasSolicitacoes cliente={cliente} />;
}
